import { createStore } from 'effector';
import { effectorStartEvent } from '@nx-frontend/shared/store/client-side';
import { Session } from '@nx-frontend/shared/types';

export const initialSessionState: Session = {
  id: '',
  ip: '',
  data: {},
  createDate: 0,
};

export const $session = createStore(initialSessionState).on(effectorStartEvent, (state) => state);

export const $sessionUserId = $session.map((state) => state.userId);
